"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkboxSize = exports.Checkbox = void 0;
var react_1 = __importDefault(require("react"));
var HiddenNativeInput_1 = require("./common/HiddenNativeInput");
var core_1 = require("./core");
function Checkbox(_a) {
    var checked = _a.checked, onChange = _a.onChange;
    return (react_1.default.createElement(Wrapper, null,
        checked ? checkedImage : uncheckedImage,
        onChange && (react_1.default.createElement(HiddenNativeInput_1.HiddenNativeInput, { checked: checked, onChange: function (event) { return onChange === null || onChange === void 0 ? void 0 : onChange(event.target.checked); }, type: 'checkbox' }))));
}
exports.Checkbox = Checkbox;
exports.checkboxSize = (0, core_1.getCustomSize)(10);
var Wrapper = (0, core_1.styled)('label', {
    display: 'block',
    lineHeight: 0,
    verticalAlign: 'top',
    width: 'fit-content',
    height: 'fit-content',
});
var checkedImage = (react_1.default.createElement("svg", { style: { fill: core_1.tokens.colors.$grey7, height: exports.checkboxSize.value, width: exports.checkboxSize.value }, xmlns: 'http://www.w3.org/2000/svg' },
    react_1.default.createElement("rect", { rx: '2', style: { height: exports.checkboxSize.value, width: exports.checkboxSize.value } }),
    react_1.default.createElement("path", { d: 'M2 5l2 2 4-4', stroke: '#fff', strokeLinecap: 'round', strokeWidth: '1.5' })));
var uncheckedImage = (react_1.default.createElement("svg", { style: {
        fill: 'none',
        height: exports.checkboxSize.value,
        stroke: core_1.tokens.colors.$grey7,
        width: exports.checkboxSize.value,
    }, xmlns: 'http://www.w3.org/2000/svg' },
    react_1.default.createElement("rect", { height: '9', rx: '1.5', width: '9', x: '.5', y: '.5' })));
